import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { InputHandler as e } from "../../../input/InputHandler.js";

var i = /*#__PURE__*/function (_e) {
  _inherits(i, _e);

  var _super = _createSuper(i);

  function i(e, _i, t) {
    var _this$_keyMap;

    var _this;

    _classCallCheck(this, i);

    _this = _super.call(this, !0), _this.view = e, _this.keys = _i, _this._pressed = !1, _this._keyMap = (_this$_keyMap = {}, _defineProperty(_this$_keyMap, _i.left, "left"), _defineProperty(_this$_keyMap, _i.right, "right"), _defineProperty(_this$_keyMap, _i.up, "up"), _defineProperty(_this$_keyMap, _i.down, "down"), _this$_keyMap), _this.registerIncoming("key-down", t, function (e) {
      return _this._handleKeyDown(e);
    }), _this.registerIncoming("key-up", t, function (e) {
      return _this._handleKeyUp(e);
    }), _this.registerIncoming("blur", t, function () {
      return _this._handleBlur();
    });
    return _this;
  }

  _createClass(i, [{
    key: "_handleKeyDown",
    value: function _handleKeyDown(e) {
      e.data.repeat || this._handleKey(e, !0);
    }
  }, {
    key: "_handleKeyUp",
    value: function _handleKeyUp(e) {
      this._handleKey(e, !1);
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      this._pressed && (this._pressed = !1, this.view.mapViewNavigation.stop());
    }
  }, {
    key: "_handleKey",
    value: function _handleKey(e, _i2) {
      var t = this._keyMap[e.data.key];

      if (this._pressed = null != t, this._pressed) {
        if (_i2) switch (this.view.mapViewNavigation.begin(), t) {
          case "left":
            this.view.mapViewNavigation.continousPanLeft();
            break;

          case "right":
            this.view.mapViewNavigation.continousPanRight();
            break;

          case "up":
            this.view.mapViewNavigation.continousPanUp();
            break;

          case "down":
            this.view.mapViewNavigation.continousPanDown();
        } else this._pressed = !1, this.view.mapViewNavigation.stop();
        e.stopPropagation();
      }
    }
  }]);

  return i;
}(e);

export { i as KeyPan };